import { Card, ErrorBox, Loading, useAsync } from '../../shared/ui';
import { api } from '../api';
import { AuditTable } from '../components/AuditTable';
import { PageHead } from '../components/PageHead';
import type { AuditEntry } from '../types';

export function AuditPage(): JSX.Element {
  const audit = useAsync(() => api.get<{ entries: AuditEntry[] }>('/admin/audit?limit=200').then((r) => r.entries), []);
  return (
    <div className="stack lg">
      <PageHead
        title="Registro"
        description="Todo lo que se ha cambiado desde el panel: altas, conexiones, usuarios, configuración. Las contraseñas nunca se apuntan."
        actions={
          <button className="btn" onClick={() => void audit.reload()} disabled={audit.loading}>
            {audit.loading ? 'Cargando…' : 'Actualizar'}
          </button>
        }
      />
      <Card bodyless title="Últimos 200 cambios">
        {audit.loading && !audit.data ? (
          <Loading />
        ) : audit.error ? (
          <div className="card-body">
            <ErrorBox error={audit.error} onRetry={() => void audit.reload()} />
          </div>
        ) : (
          <AuditTable entries={audit.data ?? []} />
        )}
      </Card>
    </div>
  );
}
